import {
  CampaignBidPriceWebService,
  RestfulCampaignBidPriceWebService
} from 'ws/CampaignBidPriceWebService';
import { CampaignBidPrice } from './CampaignBidPrice';
import { cloneDeep } from 'lodash';

export interface CampaignBidPriceManager {
  getDefaultCampaignBidPrices (): Promise<CampaignBidPrice[]>;
  mergeCampaignBidPrices (
    defaultCampaignBidPrices: CampaignBidPrice[],
    bidPriceSetting: CampaignBidPrice[]
  ): CampaignBidPrice[];
}

export class DefaultCampaignBidPriceManager implements CampaignBidPriceManager {
  constructor (
    private webService: CampaignBidPriceWebService = new RestfulCampaignBidPriceWebService()
  ) {}

  async getDefaultCampaignBidPrices (): Promise<CampaignBidPrice[]> {
    return this.webService.getDefaultCampaignBidPrices();
  }

  mergeCampaignBidPrices (
    defaultCampaignBidPrices: CampaignBidPrice[],
    bidPriceSetting: CampaignBidPrice[]
  ): CampaignBidPrice[] {
    return defaultCampaignBidPrices.map((item) => {
      const found = bidPriceSetting.find(
        (addonItem) => addonItem.type === item.type
      );
      if (found) {
        return {
          ...item,
          autoBidCap: {
            ...item.autoBidCap,
            ...found.autoBidCap
          },
          bidFloor: {
            ...item.bidFloor,
            ...found.bidFloor
          }
        };
      }
      return cloneDeep(item);
    });
  }
}
